// extracted by mini-css-extract-plugin
export default {"Full":"Skeleton_Full__0cWXE"};